import { apiConstatnts } from "constants/apiConstants";
import moment from "moment";
import { store } from "store";
import httpRequset from "utils/HttpRequest";
import queryString from "query-string";
import { CalculateVenuePrice, UploadVenueBookingPaymentReceipt } from "types/venue";
import { compressImage } from "utils/compressImage";
import { QueryParams } from "types/query";

const { REACT_APP_API_URL, REACT_APP_ACCESS_TOKEN, REACT_APP_DEFAULT_VENUE_ID } = process.env;

async function createVenueBooking(
  venue_id: number,
  start_date_time: string,
  end_date_time: string,
  contact_email: string | null,
  contact_phone: string | null,
  remarks: string | null,
  points?: number | null,
  vouchers?: any
) {
  try {
    const url = `${REACT_APP_API_URL}/venue-booking/create`;

    const body = JSON.stringify({
      venue_id: venue_id,
      user_id: store.getState()!.auth.user!["user_id"],
      status: 2,
      start_date_time: moment(start_date_time).format("YYYY-MM-DD HH:mm:ss"),
      end_date_time: moment(end_date_time).format("YYYY-MM-DD HH:mm:ss"),
      contact_email: contact_email,
      contact_phone: String(contact_phone),
      remarks: remarks,
      points: points,
      vouchers: vouchers,
    });

    return httpRequset(apiConstatnts.POST, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, body);
  } catch (error) {
    throw error;
  }
}

// async function getVenueBookingsByVenueIdAndUserId(venue_id: number,  status: number, limit: number = 5, offset: number = 0) {

async function getVenueBookingsByVenueIdAndUserId(venue_id: number, queryParams: QueryParams) {
  try {
    const user = store.getState().auth.user;

    const url = `${REACT_APP_API_URL}/venue-booking/user/${user!["user_id"]}/venue/${venue_id}${queryParams ? `?${queryString.stringify(queryParams)}` : ""}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
}

async function getVenueByVenueId(venue_id: number) {
  try {
    const queryParams = {
      filter: `[venue_id:eq:${venue_id}]`,
    };

    const url = `${REACT_APP_API_URL}/venue/getVenues?${queryString.stringify(queryParams)}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
}

async function getVenuePhotoAlbumByVenueId(venue_id: number) {
  try {
    const url = `${REACT_APP_API_URL}/venue-image/getVenueImages/${venue_id}/0`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
}

async function getVenuePriceByVenueId(venue_id: number, searchParams: Object) {
  try {
    const url = `${REACT_APP_API_URL}/venue-price/${venue_id}?${queryString.stringify(searchParams)}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

async function calculateVenuePriceByDateTime(params: CalculateVenuePrice) {
  try {
    const url = `${REACT_APP_API_URL}/venue-price/slots/calculate/${params.venue_id}?${queryString.stringify(params.dateTime)}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

async function getVenueBookingDisountedPrice(params: CalculateVenuePrice, points?: number | null, vouchers?: any | null) {
  try {
    const user = store.getState().auth.user;

    const url = `${REACT_APP_API_URL}/venue-booking/discount`;

    const body = JSON.stringify({
      user_id: user!["user_id"],
      venue_id: params.venue_id,
      start_date_time: params.dateTime.start_date_time,
      end_date_time: params.dateTime.end_date_time,
      points: points,
      vouchers: vouchers,
    });

    return httpRequset(apiConstatnts.POST, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, body);
  } catch (error) {
    throw error;
  }
}

async function getVenueFacilities() {
  try {
    const queryParams = {
      filter: `[venue_id:eq:${REACT_APP_DEFAULT_VENUE_ID}]`,
    };

    const url = `${REACT_APP_API_URL}/venue-facility?${queryString.stringify(queryParams)}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

async function uploadVenueBookingPaymentReceipt(params: UploadVenueBookingPaymentReceipt, image: File) {
  try {
    const url = `${REACT_APP_API_URL}/venue-booking/payment/update-payment-proof/${params.venue_booking_id}`;

    const myHeaders = new Headers();
    myHeaders.append("authorization", `Bearer ${REACT_APP_ACCESS_TOKEN}`);

    const compressedImage = await compressImage(image);

    const formData = new FormData();

    Object.keys(params).forEach(function (key: string) {
      if (params[key as keyof UploadVenueBookingPaymentReceipt] != null) {
        formData.append(key, String(params[key as keyof UploadVenueBookingPaymentReceipt]));
      }
    });

    formData.append("payment-proof", compressedImage);

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions as any);

    const rawData = await response.text();

    const data = JSON.parse(rawData);

    return data.data;
  } catch (error) {
    throw error;
  }
}

async function getVenueClosePeriods() {
  try {
    const url = `${REACT_APP_API_URL}/venue-close-period/${REACT_APP_DEFAULT_VENUE_ID}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

async function getVenueBookings() {
  try {
    const url = `${REACT_APP_API_URL}/venue-booking/getVenueBookingsByVenueId/${REACT_APP_DEFAULT_VENUE_ID}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

async function getVenueSlotBlocks(startDate: string, endDate: string) {
  try {
    const url = `${REACT_APP_API_URL}/venue-booking/get-booking-time-slots/${REACT_APP_DEFAULT_VENUE_ID}?start_date_time=${startDate}&end_date_time=${endDate}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

async function getVenueDefaultPriceByVenueId(venue_id: number, searchParams?: Object) {
  try {
    const url = `${REACT_APP_API_URL}/venue-price/default/get/${venue_id}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

async function getVenueOneTimePeriodPriceByVenueId(venue_id: number, searchParams?: QueryParams) {
  try {
    const url = `${REACT_APP_API_URL}/venue-price/one-time/get/${venue_id}${searchParams ? `?${queryString.stringify(searchParams)}` : ""}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

async function getVenueRepeatPeriodPriceByVenueId(venue_id: number, searchParams?: QueryParams) {
  try {
    const url = `${REACT_APP_API_URL}/venue-price/repeat/get/${venue_id}${searchParams ? `?${queryString.stringify(searchParams)}` : ""}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

async function cancelVenueBooking(venue_booking_id: number) {
  try {
    const url = `${REACT_APP_API_URL}/venue-booking/status/update/${venue_booking_id}/0`;

    return httpRequset(apiConstatnts.PUT, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
}

export const venueService = {
  createVenueBooking,
  getVenueFacilities,
  getVenueBookingsByVenueIdAndUserId,
  getVenueByVenueId,
  getVenuePhotoAlbumByVenueId,
  getVenuePriceByVenueId,
  calculateVenuePriceByDateTime,
  getVenueBookingDisountedPrice,
  uploadVenueBookingPaymentReceipt,
  getVenueClosePeriods,
  getVenueBookings,
  getVenueSlotBlocks,
  getVenueDefaultPriceByVenueId,
  getVenueOneTimePeriodPriceByVenueId,
  getVenueRepeatPeriodPriceByVenueId,
  cancelVenueBooking,
};
